import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ReferenceDataConstants } from '../../lib/constants/reference-data-constants';

@Injectable({
  providedIn: 'root'
})
export class ApplicationHostTypeService {
  private static readonly PropositionsInterfaces = [
    {
      code: 'boi',
      cssClasses: ['boi'],
      hash: '2e04355b76337a514a23e01f7eddba2b852609f9'
    },
    {
      code: 'op',
      cssClasses: ['boi', 'direct'],
      hash: '824f601c2a81ee6bab79ccd4792304c738d17630'
    },
    {
      code: 'boid',
      cssClasses: ['boi', 'direct'],
      hash: 'd69945e83457775acd78ad680d437f62ad83ef24'
    }
  ];

  private code: string;
  private interfaceType: number;

  constructor(@Inject(DOCUMENT) private readonly _document) {}

  public updateCode(): void {
    this.code = window.location.pathname.split('/')[2]?.toLowerCase();
  }

  public updateFavicon(): void {
    this._document.getElementById('appFavicon').setAttribute('href', `assets/${this.code}-favicon.ico`);
  }

  public setInterfaceType(value: number): void {
    this.interfaceType = value;
  }

  public getInterfaceType(): number {
    return this.interfaceType;
  }

  public getCode(): string {
    return this.code;
  }

  public getHash(): string {
    const propositionInterface = ApplicationHostTypeService.PropositionsInterfaces.find(
      (item) => item.code === this.code
    );

    return propositionInterface ? propositionInterface.hash : null;
  }

  public getPropositionInterfaceCssClasses(): Array<string> {
    const propositionInterfaceCss = ApplicationHostTypeService.PropositionsInterfaces.find(
      (item) => item.code === this.code
    );

    return propositionInterfaceCss ? propositionInterfaceCss.cssClasses : [];
  }

  public isBrokerInterfaceType(): boolean {
    return this.getInterfaceType() === ReferenceDataConstants.BROKER_INTERFACE_TYPE_ID;
  }

  public isDirectInterfaceType(): boolean {
    return this.getInterfaceType() === ReferenceDataConstants.DIRECT_INTERFACE_TYPE_ID;
  }
}
